export const HINT_VALUES = {
    Logout: "logout",
    Login: "login"
}

export const ACTION_VALUES = {
    Logout: "logout",
    Clear: "clear"
} 


export const PAYMENT_VALUES = {
    ETransfer: "e-transfer",
    Prepaid: "prepaid"
}